// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171804/js/" + chunkId + "." + {"44":"39d399f9","225":"ae751cb4","481":"4dab7369","486":"7a888554","770":"bef031aa"}[chunkId] + ".0.5378067561494038.chunk.js";
};